import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { SEO } from '../components/SEO';
import { motion } from 'framer-motion';
import { SITE } from '../data/site';

const ThankYouPage = () => (
  <>
    <SEO title="Thank You | Nebraska Backyard Living" description="Thank you for your quote request. We'll be in touch shortly to schedule your free consultation." path="/thank-you/" noindex />
    <section className="flex min-h-[80vh] items-center pt-24">
      <div className="container-site max-w-2xl py-24 text-center">
        <motion.div initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}>
          <CheckCircle2 className="mx-auto h-14 w-14 text-bronze" aria-hidden="true" />
        </motion.div>
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2, duration: 0.6 }}>
          <p className="overline-label mt-8">Request Received</p>
          <h1 data-testid="thank-you-heading" className="mt-4 font-serif text-4xl font-medium tracking-tight text-ink sm:text-5xl">
            Thank you — we're on it
          </h1>
          <p className="mx-auto mt-6 max-w-md text-lg leading-relaxed text-muted2">
            Your quote request has been received. A member of our team will reach out shortly to schedule your free on-site consultation.
          </p>
          <p className="mt-6 text-sm text-muted2">
            Want to talk sooner? Call us at <a href={SITE.phoneHref} data-testid="thank-you-phone" className="font-semibold text-bronze">{SITE.phone}</a>
          </p>
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <Link to="/projects/" data-testid="thank-you-work-link" className="btn-outline">Explore Our Work</Link>
            <Link to="/blog/" data-testid="thank-you-blog-link" className="btn-outline">Get Inspired</Link>
          </div>
        </motion.div>
      </div>
    </section>
  </>
);

export default ThankYouPage;
